import React, { useState, useEffect, useContext } from 'react';
import { useRouter } from 'next/router';
import styled from '@lib/styled';
import dynamic from 'next/dynamic';
import {
  FacebookOutlined,
  RightCircleOutlined,
  MailOutlined
} from '@ant-design/icons';
import Header from '@atoms/Header';
import Footer from '@atoms/Footer';
import { Timeline, Typography, Divider, Anchor } from 'antd';
import Button from '@components/atoms/Button';
import Logo from '@icons/Logo';
import { Image, Collapse } from '@chakra-ui/core';
import brand from '@lib/brand';
const { Text, Title } = Typography;
const { Link } = Anchor;

function About() {
  const [showEmail, setShowEmail] = useState(false);
  return (
    <>
      <Header />
      <Container>
        <DetailsContainer>
          <IntroBox>
            <br />
            <br />
            <br />
            <Title>About</Title>
            <Title level={3}>
              We are volunteers fighting to give the ABA community the tooling
              it deserves.
            </Title>
            <Text style={{ margin: 0 }}>
              Hi! We're a volunteer community of ABA professionals who met
              exchanging advice and guidance in our open Facebook group,
              Telehealth in ABA. We are currently doing everything we can to
              help the ABA community deliver their best work amidst the COVID
              pandemic.
            </Text>
            <br />
            <Title level={3}>Background</Title>
            <Text style={{ margin: 0 }}>
              Given the urgency to share our tools with the ABA community, we
              don't always have the time to write everything out here; we
              usually prioritize building more product.
              <br />
              <br />
              That being said, we are happy to help however we can and provide
              whatever background you are curious about.
              <br />
              <br />
              If you are a BCBA, RBT, educator, or parent, please feel free to
              reach out to us below, or check out <a href="/faq">our FAQ</a>.
            </Text>
            <Title level={3}>Getting involved</Title>
            <Text style={{ margin: 0 }}>
              We are constantly in need of more hands on deck. If you are
              interested in volunteering or otherwise supporting our work, we
              invite you to learn more{' '}
              <a href="/volunteer">on our volunteer page</a>.
            </Text>
            <Divider></Divider>

            <Collapse mt={1} isOpen={showEmail}>
              <Text style={{ margin: 0 }}>Email us at</Text>
              <Title level={4} style={{ margin: 0 }} copyable>
                {brand.tagline}
              </Title>
              <br />
            </Collapse>

            <Button
              ghost
              icon={<MailOutlined />}
              style={{ width: 240 }}
              // shape="round"
              size="large"
              type="primary"
              onClick={() => setShowEmail(true)}
              href={`mailto:${brand.team_email}`}>
              Contact Us
            </Button>

            <br />
            <Button
              icon={<FacebookOutlined />}
              style={{ width: 240 }}
              // shape="round"
              size="large"
              type="primary"
              ghost
              href="https://www.facebook.com/groups/668891769907036/">
              Visit Community Page
            </Button>

            <br />
            <Button
              icon={<RightCircleOutlined />}
              style={{ width: 240 }}
              // shape="round"
              size="large"
              type="primary"
              href="/manage">
              Get Started
            </Button>
          </IntroBox>
          <Divider></Divider>
        </DetailsContainer>
      </Container>
      <Footer />
    </>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  min-height: 90vh;
  width: 100%;
  flex: 1;
`;

const IntroBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  max-width: 600px;
  flex: 1;
`;

const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding-left: 4vw;
  padding-right: 4vw;
  /* max-width: 1200px; */
  /* margin: 10px auto; */
  min-height: 70vh;
  flex: 1;
`;

const Jumbo = styled(Title)`
  font-size: 90px;
`;

export default About;
